import { useCookies } from '../useCookies';

export const useClientCountryCode = () => {
  const {
    cookies: { clientCountryCode }
  } = useCookies();

  return clientCountryCode;
};
